(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elx-water-purifier-editorial"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-elx-wp-editorial-v3="true"]') || document.querySelector('.elx-wp-editorial-v3');
    if (!root) return;
    const copy = root.querySelector('[data-elx-editorial-copy]');
    const more = root.querySelector('[data-elx-editorial-more]');
    if (!copy || !more) return;
    more.addEventListener('click', () => {
      const expanded = copy.classList.toggle('is-expanded');
      more.setAttribute('aria-expanded', String(expanded));
      more.innerHTML = expanded ? 'Less <span aria-hidden="true">⌃</span>' : 'More <span aria-hidden="true">⌄</span>';
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elx-water-purifier-scenario-switcher"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-elx-wp-scenarios]');

    roots.forEach((root) => {
      if (root.dataset.enhanced === 'true') return;
      root.dataset.enhanced = 'true';

      const tabs = Array.from(root.querySelectorAll('[data-elx-scene-tab]'));
      const thumbs = Array.from(root.querySelectorAll('[data-elx-product-thumb]'));
      const media = root.querySelector('[data-elx-scene-media]');
      const image = root.querySelector('[data-elx-scene-image]');
      const video = root.querySelector('[data-elx-scene-video]');
      const panel = root.querySelector('[data-elx-scene-panel]');
      const kicker = root.querySelector('[data-elx-scene-kicker]');
      const title = root.querySelector('[data-elx-scene-title]');
      const copy = root.querySelector('[data-elx-scene-copy]');
      const cta = root.querySelector('[data-elx-scene-cta]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let videoActivated = false;

      const revealMedia = () => requestAnimationFrame(() => media.classList.remove('is-switching'));
      const showImage = (next, source = next.dataset.image || '') => {
        video.pause();
        video.hidden = true;
        image.hidden = false;
        const updateImage = () => {
          image.src = source;
          image.alt = next.dataset.alt || '';
          revealMedia();
        };
        const nextImage = new Image();
        nextImage.src = source;
        if (nextImage.complete) updateImage();
        else nextImage.addEventListener('load', updateImage, { once: true });
      };

      const showVideo = (next) => {
        const source = next.dataset.video || '';
        videoActivated = true;
        const showFallback = () => showImage(next, next.dataset.fallbackImage || '');
        if (!source) {
          showFallback();
          return;
        }
        image.hidden = true;
        video.hidden = false;
        video.setAttribute('aria-label', next.dataset.alt || '');
        video.poster = next.dataset.poster || '';

        const playVideo = () => {
          try { video.currentTime = 0; } catch { /* Metadata has not loaded yet. */ }
          if (!reducedMotion) video.play().catch(showFallback);
          revealMedia();
        };

        if (video.dataset.source !== source) {
          video.dataset.source = source;
          video.src = source;
          video.addEventListener('loadeddata', playVideo, { once: true });
          video.addEventListener('error', showFallback, { once: true });
          video.load();
        } else {
          playVideo();
        }
      };

      const setScene = (scene, shouldFocus = false) => {
        const next = tabs.find((tab) => tab.dataset.scene === scene);
        if (!next || next.getAttribute('aria-selected') === 'true') return;

        tabs.forEach((tab) => {
          const active = tab === next;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
        });
        thumbs.forEach((thumb) => thumb.classList.toggle('is-active', thumb.dataset.scene === scene));

        media.classList.add('is-switching');
        if (next.dataset.media === 'video') showVideo(next);
        else showImage(next);

        kicker.textContent = next.dataset.kicker || '';
        title.textContent = next.dataset.title || '';
        copy.textContent = next.dataset.copy || '';
        cta.href = next.dataset.url || '#';
        cta.textContent = next.dataset.cta || 'Explore';
        panel.setAttribute('aria-labelledby', next.id);

        if (shouldFocus) next.focus();
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => setScene(tab.dataset.scene));
        tab.addEventListener('keydown', (event) => {
          let nextIndex = null;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;
          if (nextIndex === null) return;
          event.preventDefault();
          setScene(tabs[nextIndex].dataset.scene, true);
        });
      });

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => setScene(thumb.dataset.scene));
      });

      const activateInitialVideo = () => {
        if (videoActivated) return;
        const initialScene = tabs.find((tab) => tab.getAttribute('aria-selected') === 'true');
        if (initialScene?.dataset.media !== 'video') return;
        media.classList.add('is-switching');
        showVideo(initialScene);
      };

      const scheduleInitialVideo = () => {
        if (videoActivated) return;
        window.setTimeout(activateInitialVideo, 900);
      };

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          observer.disconnect();
          scheduleInitialVideo();
        }, { rootMargin: '160px 0px' });
        observer.observe(root);
      } else {
        scheduleInitialVideo();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
